import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import pilgrim from "../assets/images/retails/pilgrim.jpg";
import weddings from "../assets/images/retails/weddings.jpg";
import familynew from "../assets/images/retails/familynew.jpg";
import packages from "../assets/images/retails/package.jpg";
import tours from "../assets/images/retails/tours.jpg";
import ticketing from "../assets/images/retails/ticketing.jpg";

function Retail() {
  return (
    <div>
      <div>
        <div className="inner-banner">
          <Container>
            <Row>
              <Col xs={8} md={12} className="pr-0">
                <div className="contact-banner text-center">
                  <h4>RETAIL Services</h4>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="section">
          <Container>
            <Row className="mt-30">
              <Col xs={12} md={4} data-aos="fade-up">
                <div className="card-service pt-40">
                  <img src={pilgrim} className="img-fluid" alt=""></img>
                  <h6>Pilgrim Tours</h6>
                  <p>
                    Stop worrying about the cost!! We are ready to provide you
                    with everything in a reliable manner. Want to enjoy safe and
                    secure holiday travels around the world. We are a large team
                    all over the world, ensuring a home-like comfort all around
                    the world. Our guidance and approach will make your every
                    pilgrimage most memorable ones.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={4} data-aos="fade-up">
                <div className="card-service pt-40" >
                  <img src={weddings} className="img-fluid" alt=""></img>
                  <h6>Elite Weddings</h6>
                  <p>
                    To add sparkle to your elite wedding, we serve the benefits
                    of welcoming your guests from all over the world. Our team
                    is experienced in handling wedding travels; so no more worry
                    about the safe arrival of the guests. Absolute comfort and
                    tension free travel to visitors is guaranteed from our side.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={4} data-aos="fade-up">
                <div className="card-service pt-40" >
                  <img src={familynew} className="img-fluid" alt=""></img>
                  <h6>Family Events & Holidays</h6>
                  <p>
                    We have all transport types to support family travel. From
                    cabs, vans, mini-vans to buses at nominal rates, luxury
                    buses, sleeper buses, long travel buses to equip cooking
                    sets all types we avail you. Considering the safety of the
                    family we nominate responsible and highly experienced
                    drivers.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={4} data-aos="fade-up">
                <div className="card-service pt-40" style={{ height: "510px" }}>
                  <img src={packages} className="img-fluid" alt=""></img>
                  <h6>Package Tours</h6>
                  <p>
                  We furnish a wide collection of packages at an optimal cost. Almost all popular packs are available at competitive prices. We are up with a broad range of packs according to your budget. Exciting offers and discounts are available along with certain packs. Grab the offer and enjoy your holiday journey with our mind-blowing packs.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={4} data-aos="fade-up">
                <div className="card-service pt-40" style={{ height: "510px" }}>
                  <img src={tours} className="img-fluid" alt=""></img>
                  <h6>Customized Tours</h6>
                  <p>
                  Apart from the popularly available packages we also tailor offers according to your needs. You can contact us in advance to arrange your personalized packs. Mention us your budget, locations to be covered and your availability we will customize the travel for you. Never miss any must-see site during the journey. We assure you 100% satisfaction.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={4} data-aos="fade-up">
                <div className="card-service pt-40" style={{ height: "510px" }}>
                  <img src={ticketing} className="img-fluid" alt=""></img>
                  <h6>Ticketing</h6>
                  <p>
                  We also book tickets in bulk or in numbers as per your wish. Our ticketing process includes registering tickets, reporting the status of booking to the customers. Any further changes in the bookings as cancellation, adding extra tickets, modifying tickets to other class of travel all the services are offered here. No more hassle in ticket booking; one stop solution for all travel types.
                  </p>
                </div>
              </Col>
            
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default Retail;
